<template>
  <b-form-group
    :id="'group' + id"
    :class="`text-input-group ${requireError ? 'require-field' : ''}`"
    :label-for="id"
    :label="`${$translate(placeholder)} ${required ? '*' : ''}`"
    :state="!isError"
    :invalid-feedback="errorMessage"
  >
    <div class="wrapper">
      <multiselect
        :id="customID || id"
        :ref="id"
        v-model="currentValue"
        :options="currentOptions"
        :close-on-select="true"
        :clear-on-select="false"
        :preserve-search="true"
        :disabled="disabled || viewMode"
        :placeholder="$translate(inputPlaceholder) || $translate(placeholder)"
        label="text"
        track-by="value"
        @input="updateValue"
      >
        <span slot="noOptions">{{ 'List is empty' | i18n }}</span>
        <span slot="noResult">{{ 'No elements found Consider changing the search query' | i18n }}</span>
      </multiselect>
    </div>
    <b-form-text>
      {{ bottomText }}
    </b-form-text>
  </b-form-group>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'Select',
  components: { Multiselect },
  props: {
    viewMode: {
      type: Boolean,
      default: false,
    },
    bottomText: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    options: {
      type: Array,
      default: () => [],
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    customID: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    inputPlaceholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    tileSize: {
      type: Number,
      default: 14,
    },
    updateError: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      currentValue: '',
      focused: false,
      id: '',
      currentOptions: this.options.map((option) => {
        if (option.value) {
          return option;
        }
        return { value: option, text: option };
      }),
    };
  },
  computed: {
    requireError: function () {
      return this.required && !this.currentValue;
    },
    isError: function () {
      const error = this.error;
      this.updateError(error);
      return error;
    },
  },
  watch: {
    options(newVal) {
      if (newVal) {
        this.currentOptions = newVal.map((option) => {
          if (option.value) {
            return option;
          }
          return { value: option, text: option };
        });
      } else {
        this.currentOptions = [];
      }
    },
    value(newVal) {
      const currentValue = this.currentOptions.find(({ value }) => value == newVal);
      this.currentValue = currentValue;
    },
  },
  mounted() {
    this.id =
      Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, '') + new Date().getTime();
    const currentValue = this.currentOptions.find(({ value }) => value == this.value);
    this.currentValue = currentValue;
  },
  methods: {
    updateValue({ value }) {
      this.$emit('input', value);
      this.onChange(value);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .d-block {
  font-size: 16px;
  line-height: 20px;
}
::v-deep .multiselect {
  &.multiselect--active {
    z-index: 100000000;
    .multiselect__tags {
      border-radius: 4px;
    }
  }
  .multiselect__tags {
    border: 1px solid #c5d0de;
    border-radius: 4px;
    font-size: 16px;
    padding: 12px 40px 12px 12px;
    display: flex;
    flex-wrap: wrap;
    .multiselect__single {
      margin-bottom: 0;
      padding-left: 0;
    }
    .multiselect__input {
      padding: 0;
      display: flex;
      align-items: center;
      margin-bottom: 0;
      font-size: 16px;
      line-height: 20px;
    }
  }
  .multiselect__select {
    height: 100%;
    padding: 0;
    background: url('../../../../assets/icons/arrow_down.svg') no-repeat scroll;
    background-position: center center;
    &::before {
      display: none;
    }
  }
  .multiselect__placeholder {
    display: flex;
    align-items: center;
    padding-left: 0;
    margin-bottom: 0;
    padding-top: 0;
    font-size: 16px;
    line-height: 20px;
  }
  .multiselect__option--selected {
    background: inherit;
    color: inherit;
  }
  .multiselect__option--highlight {
    background: #f5f7f9;
    color: inherit;
  }
  .multiselect__option::after {
    display: none;
  }
  .multiselect__option {
    padding: 8px 12px;
    min-height: auto;
  }
  .multiselect__content-wrapper {
    border: none;
    box-shadow: -1px -1px 16px rgba(15, 32, 65, 0.04), 1px 1px 12px rgba(15, 32, 65, 0.04);
    .multiselect__content {
      padding: 8px 0;
    }
  }
}

.wrapper {
  display: flex;
}

.text-input-group {
  position: relative;
}
.text-input-group.require-field,
.text-input-group.is-invalid {
  color: #ed3232;
}
</style>
